// extracted by mini-css-extract-plugin
export default {"lntInputNumber":"styles_lnt-input-number__sw-sh"};